import { useState } from "react";
import { Bell, Loader2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";

var API = "/api";

export default function NotifyMeButton({ productId, productName }) {
  var [isOpen, setIsOpen] = useState(false);
  var [email, setEmail] = useState("");
  var [isSubmitting, setIsSubmitting] = useState(false);
  var [isSubscribed, setIsSubscribed] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    axios.post(API + "/notify-me", { product_id: productId, product_name: productName, email: email })
      .then(function() {
        setIsSubscribed(true);
        toast.success("We'll notify you when it's back in stock!");
        setTimeout(function() { setIsOpen(false); }, 2000);
      })
      .catch(function() { toast.error("Failed to subscribe"); })
      .finally(function() { setIsSubmitting(false); });
  }

  if (isSubscribed) {
    return (
      <div className="flex items-center gap-2 text-[#8CB369] py-2">
        <Check className="w-4 h-4" />
        <span className="text-sm">You'll be notified!</span>
      </div>
    );
  }

  return (
    <div>
      {!isOpen ? (
        <Button onClick={function() { setIsOpen(true); }} className="btn-secondary w-full" data-testid="notify-me-button">
          <Bell className="w-4 h-4 mr-2" />Notify Me When Available
        </Button>
      ) : (
        <form onSubmit={handleSubmit} className="flex gap-2" data-testid="notify-me-form">
          <Input type="email" value={email} onChange={function(e) { setEmail(e.target.value); }} placeholder="Enter your email" className="input-tactical flex-1" required data-testid="notify-me-email" />
          <Button type="submit" className="btn-primary" disabled={isSubmitting} data-testid="notify-me-submit">
            {isSubmitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Bell className="w-4 h-4" />}
          </Button>
        </form>
      )}
    </div>
  );
}
